import { isToday, isThisWeek, isThisMonth } from 'date-fns';
import { resolveDisplayStatus } from './callStatus';

export function matchesDateFilter(callTime, filter) {
  if (!callTime || filter === 'all') return true;
  const date = new Date(callTime);
  if (Number.isNaN(date.getTime())) return false;
  if (filter === 'today') return isToday(date);
  if (filter === 'week') return isThisWeek(date, { weekStartsOn: 1 });
  if (filter === 'month') return isThisMonth(date);
  return true;
}

export function filterCalls(calls, { searchTerm = '', statusFilter = 'all', dateFilter = 'all' }) {
  const q = searchTerm.trim().toLowerCase();
  return calls.filter((call) => {
    const matchesSearch =
      !q ||
      (call.phoneNumber || '').toLowerCase().includes(q) ||
      (call.summary || '').toLowerCase().includes(q) ||
      (call.serviceType || '').toLowerCase().includes(q) ||
      (call.carModel || '').toLowerCase().includes(q) ||
      (call.appointment?.plate || '').toLowerCase().includes(q) ||
      (call.appointment?.customerPhone || '').toLowerCase().includes(q);

    const displayStatus = resolveDisplayStatus(call);
    const matchesStatus =
      statusFilter === 'all' ||
      displayStatus === statusFilter ||
      (statusFilter === 'Info Provided' && call.status === 'Success' && displayStatus === 'Info Provided');
    const matchesDate = matchesDateFilter(call.callTime, dateFilter);
    return matchesSearch && matchesStatus && matchesDate;
  });
}
